module.exports = __webpack_public_path__ + "img/reusable_sponge_splash.37861174.jpg";